import siteBaseTheme from './siteBaseTheme';

const siteButtonTheme = {
    button: {
        fontFamily: 'Outfit, sans-serif',
        lineHeight: 1.5,
        muted: {
            background: siteBaseTheme.base.colors.muted,
            border: siteBaseTheme.base.colors.muted,
        },
    },
};

export default siteButtonTheme;
